import { render, staticRenderFns } from "./modalImportarTraslados.vue?vue&type=template&id=61e6f5b0&"
import script from "./modalImportarTraslados.vue?vue&type=script&lang=js&"
export * from "./modalImportarTraslados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports